"use client";

import Image from "next/image";
import dynamic from "next/dynamic";

import { useReducedEnvironment } from "@/hooks/usePerformancePreferences";

// WebGL monogram yalnız client tarafında yüklensin — ssr: false olduğu
// için `HeroMonogram3D` hiçbir zaman Sunucu JS bundle'ına girmiyor.
// Turbopack bu import için ayrı bir chunk oluşturur: three + @react-three
// paketlerinin tamamı sadece kullanıcı monogramı görmeye hak kazandığında
// fetch edilir.
const HeroMonogram3D = dynamic(
  () => import("./HeroMonogram3D").then((mod) => mod.HeroMonogram3D),
  {
    ssr: false,
    loading: () => <MonogramPlaceholder />,
  },
);

function MonogramPlaceholder() {
  return (
    <div className="relative mx-auto aspect-square w-full max-w-[360px] md:max-w-[560px]">
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 grid place-items-center"
      >
        <Image
          src="/brand/logo-mi-mark.svg"
          alt=""
          width={560}
          height={315}
          priority
          unoptimized
          className="h-auto w-[72%] max-w-[420px]"
          style={{
            filter:
              "drop-shadow(0 0 48px rgba(30,63,232,0.6)) drop-shadow(0 0 120px rgba(59,126,255,0.4))",
          }}
        />
      </div>
    </div>
  );
}

export function HeroMonogram3DLoader() {
  // `null` = henüz hydrate olmadık → SSR ile aynı placeholder'ı göster.
  // true  = reduced-motion veya reduced-data aktif → WebGL'i hiç yükleme.
  // false = her şey normal → dinamik import tetiklenir.
  const reduced = useReducedEnvironment();

  if (reduced === null || reduced) return <MonogramPlaceholder />;
  return <HeroMonogram3D />;
}
